import Icon from '@ant-design/icons';
import styled from 'styled-components';
import BackIcon from '../../icons/mobility/back.svg';
import LocalButton from './Button';

const Button = styled(LocalButton)`
    .ant-page-header-back & {
        margin-left: -0.9375rem;
    }

    &.ant-btn {
        & .anticon {
            font-size: 1.5rem;
            width: 1.5rem;
            height: 1.5rem;
            transform: translateX(-0.25rem);
        }

        & .anticon + span {
            margin-left: 0px;
            line-height: 1.5rem;
        }
    }
`;

const BackButton = props => <Button {...props} icon={<Icon component={BackIcon} />} />;

export default BackButton;
